import { tss } from 'tss-react';
import { keyframes } from 'tss-react';

import STATUS from 'types/ShoppingCart/Status';

interface IProps {
	status: STATUS;
	style?: React.CSSProperties;
}

const StatusDot = ({ status, style }: IProps) => {
	const { classes } = useStyles();

	const getClassName = (): string => {
		switch (status) {
			case STATUS.LIVE:
				return classes.liveStatus;
			case STATUS.APPROVED:
				return classes.approvedStatus;
			default:
				return classes.reviewStatus;
		}
	};

	return (
		<span className={getClassName()} style={style}>
			●
		</span>
	);
};

export default StatusDot;

const blink = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
`;

export const useStyles = tss.create({
	liveStatus: {
		fontWeight: 'bolder',
		animation: `${blink} 1s infinite`,
		color: 'green',
	},
	reviewStatus: {
		fontWeight: '500',
		animation: `${blink} 1s infinite`,
		color: 'blue',
	},
	approvedStatus: {
		fontWeight: '500',
		color: 'gray',
	},
});
